import React from 'react';

function WhyChooseDigitalMarketingServices() {
  const scrollToForm = () => {
    const formEl = document.getElementById('digital-marketing-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="why-choose-services-section">
      <div className="container">
        {/* Centered Top Header */}
        <div className="why-choose-services-header">
          <span className="why-choose-services-eyebrow">Why Choose Us</span>
          <h2 className="why-choose-services-title">
            Why Choose Our <span className="text-red">Digital Marketing Services</span>
          </h2>
        </div>

        {/* 2-Column Grid: Image (Left) & Content (Right) */}
        <div className="why-choose-services-grid">
          {/* Left Column: 3D Icons Showcase Image */}
          <div className="why-choose-services-left">
            <div className="why-choose-services-img-wrapper">
              <img 
                src="/assets/images/digital-marketing/dig-img4.jpg" 
                alt="Why Choose Our Digital Marketing Services" 
                className="why-choose-services-img"
              />
            </div>
          </div>

          {/* Right Column: Descriptions & Action Button */}
          <div className="why-choose-services-right">
            <p className="why-choose-services-desc">
              Experts Communication helps businesses and brands grow with the assistance of digital mediums. Our team wants to make you successful with our strategies and years of experience. We use the best and cost-effective tools for marketing and advertising. Our online marketing company maintains transparent communication with the clients and provides them with a complete report about their campaign performance and insights.
            </p>

            <p className="why-choose-services-desc">
              We prioritize your satisfaction and provide you with the best services that can be advantageous for your brand identity and returns. Our digital marketers know how to use multiple channels and drive the best results from them.
            </p>

            <button className="btn-dig-primary btn-boost-platforms" onClick={scrollToForm}>
              Let's Boost Your Digital Platforms
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseDigitalMarketingServices;
